import { render } from "./GlobalBanners.vue?vue&type=template&id=7b1ecb33"
import script from "./GlobalBanners.vue?vue&type=script&lang=js"
export * from "./GlobalBanners.vue?vue&type=script&lang=js"

import "./GlobalBanners.vue?vue&type=style&index=0&id=7b1ecb33&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__